import React, { Fragment } from 'react';
import { DeviceEntry } from './DeviceEntry';
import { InfoIcon }  from '../../../components/InfoIcon';

export const DeviceEntries = ({ tenant, devices, handleDelete, handleEdit }) => {
   
    const renderDevices = () => {
        const devicesRendered = devices.map(device => {
            return <DeviceEntry key={device.deviceId} tenant={tenant} device={device} handleDelete={handleDelete} handleEdit={handleEdit}/>
        });
        
        return <Fragment>
                {devicesRendered}
            </Fragment>;
    }

    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Reference</th>
                        <th scope="col">
                            Licensed
                            <InfoIcon tooltip='The device will be licensed automatically when the total quantity of all the available licenses is sufficient. A non-licensed device will not be able to connect to the Zorgmessenger service.'/>                            
                        </th>
                        <th scope="col">Contact Group</th>
                        <th scope="col">IQ messenger connection</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {renderDevices()}
                </tbody>
            </table>           
        </div>
    )
}